import { images } from "../data/portfolioData";

function KineticHero() {
  return (
    <section className="hero-section" data-section="top" data-testid="hero-section">
      <div className="hero-copy">
        <div className="eyebrow-row hero-eyebrow" data-testid="hero-availability-badge"><span className="status-dot" />AVAILABLE FOR GLOBAL KEYNOTES + STRATEGIC ADVISORY</div>
        <h1 className="hero-title" data-testid="hero-kinetic-headline">
          <span className="hero-line-mask"><span className="hero-line hero-line-one">I BUILD</span></span>
          <span className="hero-line-mask"><span className="hero-line hero-line-two">SYSTEMS THAT</span></span>
          <span className="hero-line-mask"><span className="hero-line hero-line-three">MOVE PEOPLE.</span></span>
        </h1>
        <p className="hero-description">Armand Mazalan translates complex cloud, data, integration, and AI problems into systems people can trust — and stories leaders can act on.</p>
        <div className="hero-actions">
          <a className="button button-accent" href="#selected-work" data-testid="hero-explore-works-btn">Explore selected work <span>↓</span></a>
          <a className="button button-quiet" href="#contact" data-testid="hero-contact-btn">Get in touch <span>↗</span></a>
        </div>
        <div className="hero-footnote"><span>01 / 05</span><span>Systems / People / Possibility</span></div>
      </div>
      <div className="hero-media">
        <figure className="hero-photo-frame">
          <img src={images.stage} alt="Armand speaking on a technology stage" data-testid="hero-spotlight-image" />
          <span className="hero-photo-index">FIELD NOTE / 001</span>
          <figcaption className="hero-photo-caption">The stage is only useful when the idea lands.</figcaption>
        </figure>
        <div className="hero-side-note">KUALA LUMPUR <span>·</span> AVAILABLE GLOBALLY</div>
      </div>
    </section>
  );
}

export default KineticHero;
